// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

.sq-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  padding: 0.875rem 1rem;
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius);
}
.sq-hero.tone-good {
  background: var(--sq-good-bg);
  border-color: var(--sq-good-line);
}
.sq-hero.tone-warn {
  background: var(--sq-warn-bg);
  border-color: var(--sq-warn-line);
}
.sq-hero.tone-bad {
  background: var(--sq-bad-bg);
  border-color: var(--sq-bad-line);
}

.sq-hero-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.sq-hero-icon {
  display: flex;
  flex-shrink: 0;
  color: var(--sq-text-3);
}
.tone-good .sq-hero-icon {
  color: var(--sq-good);
}
.tone-warn .sq-hero-icon {
  color: var(--sq-warn);
}
.tone-bad .sq-hero-icon {
  color: var(--sq-bad);
}

.sq-hero-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
}

.sq-hero-sub {
  margin: 0.1rem 0 0;
  font-size: 0.8125rem;
  color: var(--sq-text-2);
}

.sq-hero-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.4rem;
  flex: 1 1 18rem;
  min-width: 0;
}
@media (max-width: 767px) {
  .sq-hero-side {
    align-items: flex-start;
    flex-basis: 100%;
  }
}

.sq-hero-issues {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.375rem;
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 100%;
}
@media (max-width: 767px) {
  .sq-hero-issues {
    justify-content: flex-start;
  }
}
.sq-hero-issues .sq-pill {
  white-space: normal;
  overflow-wrap: anywhere;
  border-radius: var(--sq-radius-sm);
}
.sq-hero-issues button {
  padding: 0;
  color: inherit;
  font: inherit;
  background: none;
  border: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-hero-issues button {
    display: inline-block;
    padding-block: 0.8rem;
    margin-block: -0.8rem;
  }
}

.sq-hero-countdown {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: var(--sq-text-2);
}

.proxy-spark {
  display: block;
  flex-shrink: 0;
  width: 100%;
  height: 26px;
  margin-top: 0.375rem;
}
.proxy-spark polyline {
  fill: none;
  stroke: var(--sq-text-3);
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}
.proxy-spark circle {
  fill: var(--sq-text-3);
  stroke: none;
}
.proxy-spark.tone-good polyline {
  stroke: var(--sq-good);
}
.proxy-spark.tone-warn polyline {
  stroke: var(--sq-warn);
}
.proxy-spark.tone-bad polyline {
  stroke: var(--sq-bad);
}
.proxy-spark.tone-good circle {
  fill: var(--sq-good);
}
.proxy-spark.tone-warn circle {
  fill: var(--sq-warn);
}
.proxy-spark.tone-bad circle {
  fill: var(--sq-bad);
}

.proxy-delta {
  display: block;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--sq-text-3);
}

.proxy-attempts {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0;
  color: var(--sq-navy);
  font: inherit;
  font-weight: 600;
  background: none;
  border: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.proxy-attempts:hover {
  color: var(--sq-brand-strong);
}
@media (pointer: coarse) {
  .proxy-attempts {
    min-height: 44px;
    min-width: 44px;
  }
}

.proxy-detail {
  display: grid;
  grid-template-columns: 9rem minmax(0, 1fr);
  gap: 0.35rem 0.75rem;
  margin: 0;
  font-size: 0.8125rem;
}
@media (max-width: 479px) {
  .proxy-detail {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.05rem;
  }
  .proxy-detail dd {
    margin-bottom: 0.45rem;
  }
}
.proxy-detail dt {
  font-weight: 500;
  color: var(--sq-text-3);
}
.proxy-detail dd {
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}
.proxy-detail pre {
  margin: 0;
  padding: 0.5rem 0.625rem;
  font-size: 0.75rem;
  background: var(--sq-surface-3);
  border-radius: 6px;
  overflow-x: auto;
  max-height: 14rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/components/ops/proxyHealth.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AApDA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kCAAA;EACA,+BAAA;AAuDF;AArDE;EACE,6BAAA;EACA,iCAAA;AAuDJ;AApDE;EACE,6BAAA;EACA,iCAAA;AAsDJ;AAnDE;EACE,4BAAA;EACA,gCAAA;AAqDJ;;AAjDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;AAoDF;AAlDE;EACE,qBAAA;AAoDJ;AAjDE;EACE,qBAAA;AAmDJ;AAhDE;EACE,oBAAA;AAkDJ;;AA9CA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAiDF;;AA9CA;EACE,kBAAA;EACA,oBAAA;EACA,uBAAA;AAiDF;;AA9CA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAiDF;AA/CE;EARF;IASI,uBAAA;IACA,gBAAA;EAkDF;AACF;;AA/CA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAkDF;AAhDE;EAVF;IAWI,2BAAA;EAmDF;AACF;AAhDE;EACE,mBAAA;EACA,uBAAA;EACA,kCAAA;AAkDJ;AA/CE;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AAiDJ;AA/CI;EAVF;IAWI,qBAAA;IACA,qBAAA;IACA,qBAAA;EAkDJ;AACF;;AA9CA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AAiDF;;AA9CA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAiDF;AA9CE;EACE,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iCAAA;AAgDJ;AA7CE;EACE,sBAAA;EACA,YAAA;AA+CJ;AA5CE;EAAuB,sBAAA;AA+CzB;AA9CE;EAAuB,sBAAA;AAiDzB;AAhDE;EAAsB,qBAAA;AAmDxB;AAlDE;EAAqB,oBAAA;AAqDvB;AApDE;EAAqB,oBAAA;AAuDvB;AAtDE;EAAoB,mBAAA;AAyDtB;;AAtDA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAyDF;;AAtDA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AAyDF;AAvDE;EACE,6BAAA;AAyDJ;AAtDE;EAlBF;IAmBI,gBAAA;IACA,eAAA;EAyDF;AACF;;AAtDA;EACE,aAAA;EACA,0CAAA;EACA,oBAAA;EACA,SAAA;EACA,oBAAA;AAyDF;AAvDE;EAPF;IAQI,qCAAA;IACA,YAAA;EA0DF;EAxDE;IACE,sBAAA;EA0DJ;AACF;AAvDE;EACE,gBAAA;EACA,uBAAA;AAyDJ;AAtDE;EACE,SAAA;EACA,YAAA;EACA,uBAAA;AAwDJ;AArDE;EACE,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAuDJ","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","@import \"../../styles/tokens.scss\";\n\n// Overall-health banner. The stat tiles and tables use the shared layer.\n.sq-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  padding: 0.875rem 1rem;\n  background: var(--sq-surface);\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius);\n\n  &.tone-good {\n    background: var(--sq-good-bg);\n    border-color: var(--sq-good-line);\n  }\n\n  &.tone-warn {\n    background: var(--sq-warn-bg);\n    border-color: var(--sq-warn-line);\n  }\n\n  &.tone-bad {\n    background: var(--sq-bad-bg);\n    border-color: var(--sq-bad-line);\n  }\n}\n\n.sq-hero-main {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.sq-hero-icon {\n  display: flex;\n  flex-shrink: 0;\n  color: var(--sq-text-3);\n\n  .tone-good & {\n    color: var(--sq-good);\n  }\n\n  .tone-warn & {\n    color: var(--sq-warn);\n  }\n\n  .tone-bad & {\n    color: var(--sq-bad);\n  }\n}\n\n.sq-hero-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 650;\n}\n\n.sq-hero-sub {\n  margin: 0.1rem 0 0;\n  font-size: 0.8125rem;\n  color: var(--sq-text-2);\n}\n\n.sq-hero-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.4rem;\n  flex: 1 1 18rem;\n  min-width: 0;\n\n  @media (max-width: $bp-phone) {\n    align-items: flex-start;\n    flex-basis: 100%;\n  }\n}\n\n.sq-hero-issues {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.375rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-width: 100%;\n\n  @media (max-width: $bp-phone) {\n    justify-content: flex-start;\n  }\n\n  // Issue text can be long (it includes upstream errors), so these wrap.\n  .sq-pill {\n    white-space: normal;\n    overflow-wrap: anywhere;\n    border-radius: var(--sq-radius-sm);\n  }\n\n  button {\n    padding: 0;\n    color: inherit;\n    font: inherit;\n    background: none;\n    border: 0;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    cursor: pointer;\n\n    @media (pointer: coarse), (max-width: $bp-phone) {\n      display: inline-block;\n      padding-block: 0.8rem;\n      margin-block: -0.8rem;\n    }\n  }\n}\n\n.sq-hero-countdown {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--sq-text-2);\n}\n\n.proxy-spark {\n  display: block;\n  flex-shrink: 0;\n  width: 100%;\n  height: 26px;\n  margin-top: 0.375rem;\n\n  // Must stay unfilled: a filled polyline closes end-to-start into a solid shape.\n  polyline {\n    fill: none;\n    stroke: var(--sq-text-3);\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    vector-effect: non-scaling-stroke;\n  }\n\n  circle {\n    fill: var(--sq-text-3);\n    stroke: none;\n  }\n\n  &.tone-good polyline { stroke: var(--sq-good); }\n  &.tone-warn polyline { stroke: var(--sq-warn); }\n  &.tone-bad polyline { stroke: var(--sq-bad); }\n  &.tone-good circle { fill: var(--sq-good); }\n  &.tone-warn circle { fill: var(--sq-warn); }\n  &.tone-bad circle { fill: var(--sq-bad); }\n}\n\n.proxy-delta {\n  display: block;\n  margin-top: 0.1rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--sq-text-3);\n}\n\n.proxy-attempts {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0;\n  color: var(--sq-navy);\n  font: inherit;\n  font-weight: 600;\n  background: none;\n  border: 0;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--sq-brand-strong);\n  }\n\n  @media (pointer: coarse) {\n    min-height: 44px;\n    min-width: 44px;\n  }\n}\n\n.proxy-detail {\n  display: grid;\n  grid-template-columns: 9rem minmax(0, 1fr);\n  gap: 0.35rem 0.75rem;\n  margin: 0;\n  font-size: 0.8125rem;\n\n  @media (max-width: 479px) {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0.05rem;\n\n    dd {\n      margin-bottom: 0.45rem;\n    }\n  }\n\n  dt {\n    font-weight: 500;\n    color: var(--sq-text-3);\n  }\n\n  dd {\n    margin: 0;\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n\n  pre {\n    margin: 0;\n    padding: 0.5rem 0.625rem;\n    font-size: 0.75rem;\n    background: var(--sq-surface-3);\n    border-radius: 6px;\n    overflow-x: auto;\n    max-height: 14rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
